define.alias("ember-composable-helpers/helpers/flatten", "calendar/helpers/flatten");